import { useRef, useEffect } from 'react';

// Minimal contentEditable rich text editor — no library needed
function RichEditor({ initialValue, onChange }) {
  const ref = useRef(null);

  // Populate on mount only — don't sync on every render to avoid cursor jumping
  useEffect(() => {
    if (ref.current) ref.current.innerHTML = initialValue || '';
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function exec(cmd, val) {
    ref.current?.focus();
    document.execCommand(cmd, false, val ?? null); // eslint-disable-line no-restricted-globals
    if (ref.current) onChange(ref.current.innerHTML);
  }

  return (
    <div className="rte-wrap">
      <div className="rte-toolbar">
        <button type="button" className="rte-btn" title="Bold"
          onMouseDown={e => { e.preventDefault(); exec('bold'); }}>
          <strong>B</strong>
        </button>
        <button type="button" className="rte-btn" title="Italic"
          onMouseDown={e => { e.preventDefault(); exec('italic'); }}>
          <em>I</em>
        </button>
        <button type="button" className="rte-btn" title="Bullet list"
          onMouseDown={e => { e.preventDefault(); exec('insertUnorderedList'); }}>
          • List
        </button>
        <span className="rte-divider" />
        <button type="button" className="rte-btn" title="Heading"
          onMouseDown={e => { e.preventDefault(); exec('formatBlock', 'h4'); }}>
          H
        </button>
        <button type="button" className="rte-btn" title="Normal paragraph"
          onMouseDown={e => { e.preventDefault(); exec('formatBlock', 'p'); }}>
          ¶
        </button>
      </div>
      <div
        ref={ref}
        className="rte-content"
        contentEditable
        suppressContentEditableWarning
        onInput={e => onChange(e.currentTarget.innerHTML)}
      />
    </div>
  );
}

export default function IntroTab({ content, onChange }) {
  const { enabled = false, title = '', body = '' } = content ?? {};

  return (
    <div className="intro-tab">
      <label className="intro-tab-enabled-row">
        <input
          type="checkbox"
          checked={enabled}
          onChange={e => onChange({ ...content, enabled: e.target.checked })}
        />
        Show intro screen on first load
      </label>

      {enabled && (
        <>
          <div className="intro-tab-field">
            <label className="intro-tab-label">Title</label>
            <input
              type="text"
              className="intro-tab-title-input"
              value={title}
              placeholder="Welcome to the Community Dashboard"
              onChange={e => onChange({ ...content, title: e.target.value })}
            />
          </div>

          <div className="intro-tab-field">
            <label className="intro-tab-label">Body</label>
            <RichEditor
              key={title} // remount editor if tab is re-opened with fresh content
              initialValue={body}
              onChange={body => onChange({ ...content, body })}
            />
          </div>

          <p className="intro-tab-note">
            Saving resets the "Do not show again" flag — all users will see the screen on next load.
          </p>
        </>
      )}
    </div>
  );
}
